export default __webpack_public_path__ + "static/media/spark_85.87883100.png";